import { CompanyName } from './interface';

export const CompaniesMap = [
  {
    name: CompanyName.CityDrinks,
    original: true,
  },
  {
    name: CompanyName.CityDrinks,
    original: false,
  },
  {
    name: CompanyName.Localee,
    original: false,
  },
  {
    name: CompanyName.Kids,
    original: true,
  },
  {
    name: CompanyName.Kids,
    original: false,
  },
  {
    name: CompanyName.Vilo,
    original: true,
  },
  {
    name: CompanyName.Vilo,
    original: false,
  },
  {
    name: CompanyName.CircleK,
    original: true,
  },
  {
    name: CompanyName.CircleK,
    original: false,
  },
  {
    name: CompanyName.Jiffy,
    original: true,
  },
  {
    name: CompanyName.Jiffy,
    original: false,
  },
  {
    name: CompanyName.Okie,
    original: true,
  },
  {
    name: CompanyName.Okie,
    original: false,
  },
  {
    name: CompanyName.Oskuhus,
    original: true,
  },
  {
    name: CompanyName.Oskuhus,
    original: false,
  },
  {
    name: CompanyName.Heimkaup,
    original: true,
  },
  {
    name: CompanyName.Heimkaup,
    original: false,
  },
  {
    name: CompanyName.Cerise,
    original: true,
  },
  {
    name: CompanyName.Cerise,
    original: false,
  },
  {
    name: CompanyName.DubaiExpress,
    original: true,
  },
  {
    name: CompanyName.DubaiExpress,
    original: false,
  },
  {
    name: CompanyName.DubaiExpressCom,
    original: true,
  },
  {
    name: CompanyName.DubaiExpressCom,
    original: false,
  },
  {
    name: CompanyName.Storrd,
    original: true,
  },
  {
    name: CompanyName.Storrd,
    original: false,
  },
  {
    name: CompanyName.MCosmetic,
    original: true,
  },
  {
    name: CompanyName.MCosmetic,
    original: false,
  },
  {
    name: CompanyName.Ocado,
    original: true,
  },
  {
    name: CompanyName.Ocado,
    original: false,
  },
];
